import React from 'react';
import { Search } from 'lucide-react';

export default function SeoForm({ seoData, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...seoData, [field]: value });
  };

  return (
    <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 space-y-6">
      <div className="flex items-center space-x-3 pb-4 border-b border-slate-800">
        <div className="p-2 rounded-xl bg-blue-500/10 border border-blue-500/20 text-blue-400">
          <Search size={20} />
        </div>
        <div>
          <h3 className="font-bold text-base text-white">Search Engine Optimization (SEO) & Social Cards</h3>
          <p className="text-xs text-slate-400">Configure how search engines and social platforms index this page</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-xs font-bold text-slate-400 mb-1">SEO Title Tag</label>
          <input
            type="text"
            value={seoData?.seoTitle || ''}
            onChange={(e) => handleChange('seoTitle', e.target.value)}
            placeholder="e.g. Managed IT Services & Security Solutions | FAJTech"
            className="w-full p-3 rounded-xl border border-slate-800 bg-slate-950 text-slate-200 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
          <span className="text-[10px] text-slate-500 mt-1 block">
            Recommended length: 50-60 characters ({seoData?.seoTitle?.length || 0} chars)
          </span>
        </div>

        <div>
          <label className="block text-xs font-bold text-slate-400 mb-1">Keywords (Comma Separated)</label>
          <input
            type="text"
            value={seoData?.keywords || ''}
            onChange={(e) => handleChange('keywords', e.target.value)}
            placeholder="IT Services, Cybersecurity, Cloud Infrastructure, FAJTech"
            className="w-full p-3 rounded-xl border border-slate-800 bg-slate-950 text-slate-200 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>
      </div>

      <div>
        <label className="block text-xs font-bold text-slate-400 mb-1">Meta Description</label>
        <textarea
          rows={3}
          value={seoData?.metaDescription || ''}
          onChange={(e) => handleChange('metaDescription', e.target.value)}
          placeholder="Detailed page summary shown in search result snippets..."
          className="w-full p-3 rounded-xl border border-slate-800 bg-slate-950 text-slate-200 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
        />
        <span className="text-[10px] text-slate-500 mt-1 block">
          Recommended length: 140-160 characters ({seoData?.metaDescription?.length || 0} chars)
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <label className="block text-xs font-bold text-slate-400 mb-1">Canonical URL</label>
          <input
            type="text"
            value={seoData?.canonicalUrl || ''}
            onChange={(e) => handleChange('canonicalUrl', e.target.value)}
            placeholder="https://fajtech.com/services/managed-it"
            className="w-full p-3 rounded-xl border border-slate-800 bg-slate-950 text-slate-200 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        <div>
          <label className="block text-xs font-bold text-slate-400 mb-1">Open Graph (OG) Image URL</label>
          <input
            type="text"
            value={seoData?.ogImage || ''}
            onChange={(e) => handleChange('ogImage', e.target.value)}
            placeholder="/uploads/social-preview.jpg"
            className="w-full p-3 rounded-xl border border-slate-800 bg-slate-950 text-slate-200 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        <div>
          <label className="block text-xs font-bold text-slate-400 mb-1">Robots Directives</label>
          <select
            value={seoData?.robots || 'index, follow'}
            onChange={(e) => handleChange('robots', e.target.value)}
            className="w-full p-3 rounded-xl border border-slate-800 bg-slate-950 text-slate-200 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          >
            <option value="index, follow">index, follow (Default)</option>
            <option value="noindex, follow">noindex, follow</option>
            <option value="noindex, nofollow">noindex, nofollow</option>
          </select>
        </div>
      </div>
    </div>
  );
}
